import React, { useState, useEffect } from 'react';
import axios from 'axios';
import LiveTableStatus from '../../components/LiveTableStatus/LiveTableStatus';

const LiveTableStatusSystemUser = () => {
    const [OutlateData, setOutlateData] = useState([]);
    const [selectedOutlet, setSelectedOutlet] = useState(null);

    useEffect(() => {
        const fetchOutlets = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_SERVER_API}outlates`);
                setOutlateData(response.data);
            } catch (error) {
                console.error('Error fetching outlets:', error);
            }
        };
        fetchOutlets();
    }, []);

    const handleOutletChange = (event) => {
        const selectedId = event.target.value;
        const selectedData = OutlateData.find(outlet => outlet.Outlate_Id.toString() === selectedId);
        
        if (selectedData) {
            const outletToStore = {
                outlate_id: selectedData.Outlate_Id,
                Outlate_Name: selectedData.Outlet_Name,
                _id: selectedData._id
            };

            // Store in localStorage
            localStorage.setItem("SelectedOutlet", JSON.stringify(outletToStore));
            window.location.reload();
            // Update state
            setSelectedOutlet(outletToStore);
        }
    };

    return (
        <div>
            <div className='mt-2'>
                <select className="form-select" aria-label="Select Outlet" onChange={handleOutletChange}>
                    <option value="" selected disabled>Select Outlet</option>
                    {OutlateData.map((outlet) => (
                        <option key={outlet._id} value={outlet.Outlate_Id}>
                            {outlet.Outlet_Name}
                        </option>
                    ))}
                </select>
            </div>
            <LiveTableStatus selectedOutlet={selectedOutlet} />
        </div>
    );
}

export default LiveTableStatusSystemUser;
